import React from 'react';
import SidebarView from './SidebarView';
import { getBoundingClientRect } from '../utils/functions';
import StagesManager from './StagesManager';
import TopicView from './views/messenger/sideBar/TopicView';

// import Responsive from '../../Responsive';





export default class TreeLook extends React.Component {
    state = {
        showTree: false,
        second: false,
        sideOpen: this.props.sideOpen ?? false,
        person: [
            { name: "Ali", des: "description", img: "", },
            { name: "Ali", des: "description", img: "", },
        ],
        line2: [
            { name: "reza", des: "description", img: "" },
            { name: "mohamad", des: "description", img: "" },
            { name: "Ali", des: "description", img: "" }

        ], line3: [
            { name: "parisa", des: "description", img: "" },
            { name: "nastrn", des: "description", img: "" },
            { name: "Ali", des: "description", img: "" }

        ],


        isOpen: {}
    }
    componentDidMount = () => {


    }

    showTree = (index) => {
        let isOpen = this.state.isOpen
        // isOpen = {}
        isOpen[index] = !isOpen[index]

        this.setState({ isOpen });

        console.log("fist", this.state.isOpen)
    }
    second = () => {
        this.setState({ showSecond: !this.state.showSecond });
        // console.log("fist")
    }

    open = (cb) => {
        this.setState({ sideOpen: true, showContent: true })

    }

    openTopic = () => {
        this.topicView.openSidebar()
    }
    openSidebar = (cb) => {
        this.open(cb)
    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    render() {

        return (
            <div>
                <div class="tree mx-3 ">
                    <ul className='d-flex'>
                        <li className=' ' >
                            {this.state.person.map((item, index) => {
                                return (
                                    <div className='d-flex'>
                                        <div className='border-profile p-1 my-3 cursor-pointer ' onClick={() => this.showTree(index)}>
                                            <div className='d-flex'>
                                                <div className='br-50 circle-bg '>
                                                </div>
                                                <div className='mld-3'>
                                                    <p className='text-small text-start mt-1'>
                                                        {item.name}
                                                    </p>
                                                    <p className='text-small text-smaller'>
                                                        {item.des}

                                                    </p>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </li>
                        <li className=''>
                            {this.state.isOpen && (
                                <ul className='mld-10 mt-3 child-2 tree-firstline' >
                                    <div className='bl-line ws-30'></div>
                                    <div className='bl-line1 ws-30'></div>
                                    <div className='bl-line2 ws-30'></div>
                                    <div className='bl-line3 ws-30'></div>
                                    <div className='bl-line4 ws-30'></div>
                                    <li className='mld-3'>
                                        {this.state.line2.map((item, index) => {
                                            return (
                                                <>
                                                    <div className='border-profile p-1 flexc my-3'>
                                                        <div className='d-flex'>
                                                            <div className='br-50 circle-bg-1 '>
                                                            </div>
                                                            <div className='mld-3'>
                                                                <p className='text-small text-start mt-1'>
                                                                    {item.name}
                                                                </p>
                                                                <p className='text-small text-smaller'>
                                                                    {item.des}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        })}
                                    </li>
                                </ul>
                            )}
                        </li>

                    </ul>

                    <button style={{ backgroundColor: "#fff" }} onClick={() => this.openSidebar()} className='flexc px-5 py-4 br-20 shadow-1'>
                        <p className='text-link mrd-2'>Group Info</p>
                        <img width={15} src='/assets/icons/arrow-link.svg' />
                    </button>

                    <SidebarView hight={"100%"} width={this.props.width} ref={el => this.topicView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "40%", md: '35%', lg: "25", xl: "20%" }}>
                        <div className='w-100 h-100 scroll-no-scrollbar'>
                            <StagesManager ref={el => this.stageManager = el} fast={true}>
                                <TopicView width={this.props.width} changeStage={this.changePage} stage={0} stageName={'topic'} />
                            </StagesManager>
                        </div>
                    </SidebarView>

                    {/* {this.state.second == true ?
                        <ul className='mld-10 mt-5 child-2 tree-firstline' >
                            <div className='bl-line ws-30'></div>
                            <div className='bl-line1 ws-30'></div>
                            <div className='bl-line2 ws-30'></div>
                            <div className='bl-line3 ws-30'></div>
                            <div className='bl-line4 ws-30'></div>
                            <li className='mld-1'>
                                {this.state.line3.map((item, index) => {
                                    return (
                                        <>
                                            <div className='border-profile p-1 flexc my-3'>
                                                <div className='d-flex'>
                                                    <div className='br-50 circle-bg '>
                                                    </div>
                                                    <div className='mld-3'>
                                                        <p className='text-small text-start mt-1'>
                                                            {item.name}
                                                        </p>
                                                        <p className='text-small text-smaller'>
                                                            {item.des}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                                })}


                            </li>


                        </ul> : null} */}
                </div>



            </div >


        )
    }
}
